export const SWITCH_DETAILS_NOTIFICATION_STATE_KEY = "dispositionNotification";

export const SWITCH_DETAILS_NOTIFICATION_TYPES = {
  DISPOSITION_SUBMITTED: "dispositionSubmitted",
  EVENT_EXECUTED: "eventExecuted",
};

export const buildSwitchDetailsNotificationState = (notificationType) => ({
  [SWITCH_DETAILS_NOTIFICATION_STATE_KEY]: notificationType,
});
